<template>
  <div class="lease-contract">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="topColumn"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
      @changeCompanyHandler="changeCompanyHandler"
    ></sirui-search>
    <sirui-table
      ref="siruiTable"
      :buttonList="menuButtonList"
      @chooseClick="chooseClick"
      :loading="loading"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @dblclickEvent="dblclickEvent"
      :data="tableData"
      :paging="true"
      :setting="false"
      :customVisible="false"
      :columns="columnList"
      show-footer
      :footer-method="footerMethod"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'contractProperty'"
            ><div>
              {{
                contractPropertyList.find((item) => item.value == row.contractProperty)?.label ?? ''
              }}
            </div></template
          >
          <template v-else-if="item.field.indexOf('rentAmount') > -1"
            ><div>
              {{
                row.expenseTypeCode
                  ? item.field === 'rentAmount' + row.expenseTypeCode
                    ? row['rentAmount' + row.expenseTypeCode]
                    : ''
                  : ''
              }}
            </div></template
          >
          <template v-else-if="item.field === 'totalRentAmount'">{{
            row[item.field] ? parseFloat(row[item.field]).toFixed(2) : row[item.field]
          }}</template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </sirui-table>
    <RelatedContractDialog
      v-if="dialogVisible"
      ref="relatedContractDialogRefs"
      @close="closeDialog"
      :dialogVisible="dialogVisible"
      :dialogTitle="dialogTitle"
      :contractId="contractId"
    />
    <ChoiceChange
      v-if="changeDialogVisible"
      :changeDialogVisible="changeDialogVisible"
      :changeContractId="changeContractId"
      @closeChangeDialog="closeChangeDialog"
    />
    <BtnDialog ref="BtnDialogRef" @resetCheckbox="resetCheckbox"></BtnDialog>
    <ExemptionSettingDialog
      ref="ExemptionSettingDialogRef"
      @getData="getData"
      :action="importUrl"
      :data="importData"
    ></ExemptionSettingDialog>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { mapState } from 'vuex';
  import BASE_API from '@/api/dataBase';
  import {
    searchColumns,
    defaultMenuList,
    defaultTableColumns,
    auditStatusList,
    contractCategoryList,
    contractStatusList,
  } from './data';
  import API from '@/api/property/leaseContract';
  // import XEUtils from 'xe-utils';
  import RelatedContractDialog from './component/relatedContract';
  import ChoiceChange from './component/choiceChange';
  import BtnDialog from './component/btnDialog.vue';
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import ExemptionSettingDialog from './component/ExemptionSettingDialog';
  import calculation from '@/common/js/calculation';
  import moment from 'moment';
  export default {
    name: 'leaseContractManage',
    mixins: [leaseContractMixin],
    components: {
      SiruiSearch,
      RelatedContractDialog,
      ChoiceChange,
      BtnDialog,
      ExemptionSettingDialog,
    },
    watch: {
      $route() {
        this.getData();
      },
    },
    created() {
      this.query.contractCompanyNo = this.userInfo.companyCode;
      this.query.contractDepartmentNo = this.userInfo.departmentCode;
    },
    // activated() {
    //   this.getData();
    // },
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
        this.setImport();
        this._getCompanyApi();
      });
    },
    data() {
      return {
        query: {
          contractCompanyNo: '',
          contractDepartmentNo: '',
          contractNo: '',
          customerName: '',
          contractCategory: '',
          signPartyName: '',
          contractStatus: '',
          auditStatus: '',
          dateStart: '',
          dateEnd: '',
          closeDateStart: '',
          closeDateEnd: '',
          contractProperty: '', //合同属性
          spaceAssetId: null, //空间
        },
        loading: false,
        auditStatusList,
        contractCategoryList,
        contractStatusList,
        menuButtonList: [],
        defaultMenuList,
        defaultTableColumns,
        columnList: [],
        multipleSelection: [],
        tableData: [],
        dialogVisible: false,
        dialogTitle: '',
        contractId: '',
        changeDialogVisible: false,
        changeContractId: '',
        importUrl: '',
        importData: {},
        companyList: [],
        departmentList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      topColumn() {
        return searchColumns(this);
      },
      contractPropertyList() {
        return [
          { value: '', label: '全部' },
          { value: '01', label: '新签' },
          { value: '02', label: '更名' },
          { value: '03', label: '续签' },
        ];
      },
    },
    activated() {
      this.resetCheckbox();
    },
    methods: {
      footerMethod({ columns, data }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 0) {
              return '合计';
            }
            if (column.property === 'spaceArea') {
              return data.reduce((cur, next) => cur + +next.spaceArea, 0).toFixed(2);
            } else if (column.property === 'rentAmount01') {
              const total = data.reduce(
                (cur, next) =>
                  calculation.accAdd(cur, next?.rentAmount01 ? +next?.rentAmount01 : 0),
                0
              );
              return this.transferAmount(total);
            } else if (column.property === 'rentAmount97') {
              const total = data.reduce(
                (cur, next) =>
                  calculation.accAdd(cur, next?.rentAmount97 ? +next?.rentAmount97 : 0),
                0
              );
              return this.transferAmount(total);
            } else if (column.property === 'rentAmount98') {
              const total = data.reduce(
                (cur, next) =>
                  calculation.accAdd(cur, next?.rentAmount98 ? +next?.rentAmount98 : 0),
                0
              );
              return this.transferAmount(total);
            } else if (column.property === 'totalRentAmount') {
              const total = data.reduce((cur, next) => cur + +next.totalRentAmount, 0).toFixed(2);
              return this.transferAmount(total);
            } else if (column.property === 'propertyAmount') {
              const total = data.reduce((cur, next) => cur + +next.propertyAmount, 0).toFixed(2);
              return this.transferAmount(total);
            } else if (column.property === 'sanitationAmount') {
              const total = data.reduce((cur, next) => cur + +next.sanitationAmount, 0).toFixed(2);
              return this.transferAmount(total);
            }
            return null;
          }),
        ];
        return footerData;
      },
      getRowRentAmount(row, detailList) {
        if (detailList != 'detailList') {
          if (!row[detailList].length) return '';
        } else {
          if (!row[detailList].length) return row.rentAmount;
        }
        let amountListObj = {};
        for (let i = 0; i < row[detailList].length; i++) {
          const item = row[detailList][i];
          if (Object.prototype.hasOwnProperty.call(amountListObj, item.spaceId.toString())) {
            amountListObj[item.spaceId.toString()].push(item);
          } else {
            amountListObj[item.spaceId.toString()] = [item];
          }
        }
        const setList = [];
        const nowDate = moment(new Date()).format('YYYY-MM-DD');
        for (const key in amountListObj) {
          if (Object.hasOwnProperty.call(amountListObj, key)) {
            const list = amountListObj[key];
            for (let j = 0; j < list.length; j++) {
              const element = list[j];
              if (j == 0 && nowDate < element.leaseDateFrom) {
                setList.push(element.chargePrice);
                break;
              }
              if (
                moment(nowDate).isBetween(element.leaseDateFrom, element.leaseDateUntil, null, '[]')
              ) {
                setList.push(element.chargePrice);
                break;
              }
              if (j == list.length - 1 && nowDate > element.leaseDateUntil) {
                setList.push(element.chargePrice);
              }
            }
          }
        }
        return Number(parseFloat(setList.reduce((pre, cur) => (pre += cur), 0)).toFixed(3));
      },
      transferAmount(num) {
        let point = this.$globalVar.qPoint;
        num = this.$utils.commafy(this.$utils.toNumber(num).toFixed(2), point);
        return num;
      },
      // 获取公司
      async _getCompanyApi() {
        console.log('开始获取公司', this.userInfo);
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        if (data.code == 0) {
          console.log(data.data, '???=====》》');
          this.companyList = data.data?.personCompanyInfo;
          console.log(this.companyList, 'companyList');
          console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

          if (!this.userInfo.companyCode) {
            const companyCode = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyCode
              : null;
            const companyName = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyName
              : null;
            this.query = {
              ...this.query,
              contractCompanyNo: companyCode,
              contractCompanyName: companyName,
            };
          } else {
            this.query = {
              ...this.query,
              contractCompanyNo: this.userInfo.companyCode,
              // settlementCompanyName: this.userInfo.companyName,
            };
          }

          this._getDepartmentByCompanyCodeApi(this.query.settlementCompanyNo, true);
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          console.log(data.data, '部门信息');
          this.departmentList = data.data?.personDepartmentInfo;
        } else {
          console.error('获取部门失败');
        }
      },
      // 切换公司
      changeCompanyHandler(val) {
        console.log(val, '切换公司');
        const item = this.companyList.find((item) => item.personCompanyCode == val);
        console.log(item, '切换公司item');
        this.query = {
          ...this.query,
          contractDepartmentNo: '',
          // settlementDepartmentName: '',
          contractCompanyNo: val,
          // settlementCompanyName: item.personCompanyName,
        };
        // 获取部门数据
        this._getDepartmentByCompanyCodeApi(val);
      },
      // 切换部门
      changeDepartmentHandler(val) {
        console.log(val, '切换部门');
        console.log(this.departmentList, 'this.departmentList');

        // const item = this.departmentList.find((item) => item.personDepartmentCode == val);
        this.query = {
          ...this.query,
          settlementDepartmentNo: val,
          // settlementDepartmentName: item.personDepartmentName,
        };
      },
      setImport() {
        this.importUrl = API.IMPORT_PARTNER;
        this.importData = {
          tenantCode: this.userInfo.tenantCode,
          access_token: this.userInfo.access_token,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          lang: this.lang,
          createBy: this.userInfo.personName,
          businessCompanyNo: this.userInfo.companyCode,
          businessCompanyName: this.userInfo.companyName,
          businessDepartmentCode: this.userInfo.departmentCode,
          businessDepartmentName: this.userInfo.departmentName,
        };
      },
      // changeCompanyHandler(val) {
      //   console.log(val, '111');
      //   if (val.prop === 'contractCompanyNo') {
      //     this.query.contractDepartmentNo = '';
      //   }
      // },
      closeDialog(val) {
        this.dialogVisible = false;
        this.dialogTitle = '';
        if (val === 'refresh') {
          this.getData();
        }
      },
      closeChangeDialog() {
        this.changeDialogVisible = false;
        this.changeContractId = '';
      },
      getButtonList() {
        this.getButtons().then((e) => {
          console.log('e', e);
          this.menuButtonList = e.length > 0 ? e : this.defaultMenuList;
          this.getColumnInfo();
        });
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(this.defaultTableColumns).then((res) => {
          console.log(res, '111');
          this.columnList = this.defaultTableColumns;
        });
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      resetCheckbox() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
      },
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      chooseClick(type) {
        console.log(type, '111');
        if (type === 'add') {
          console.log('add');
          this.handleAdd();
        } else if (type === 'change') {
          this.handleChange();
        } else if (type === 'audit') {
          this.handleAudit();
        } else if (type === 'renewal') {
          this.handleRenewal();
        } else if (type === 'relatedContract') {
          this.handleRelatedContract();
        } else if (type === 'export') {
          this.handleExport();
        } else if (type === 'suspend') {
          this.handleSuspend();
        } else if (type === 'enable') {
          this.handleEnable();
          // this.handleDelete();
        } else if (type === 'delete') {
          this.handleDelete();
        } else if (type === 'exemption') {
          this.handleExemption();
        } else {
          this.handleClose();
        }
      },
      // 减免设置
      handleExemption() {
        console.log('减免设置');
        this.$refs.ExemptionSettingDialogRef.openDialog(true, '098');
      },
      // 暂停 只有合同状态为生效中才可进行暂停
      handleSuspend() {
        console.log('suspend');
        if (this.resolveSelected('more')) {
          const selectedList = this.multipleSelection || [];
          let hasErrorStatus = false;
          selectedList.map((item) => {
            if (item.contractStatus !== '02' || ['05', '06', '07'].includes(item.auditStatus)) {
              hasErrorStatus = true;
            }
          });
          if (hasErrorStatus) {
            return this.$message({
              showClose: true,
              message: '您选择的合同中有不满足暂停条件的合同，请确认。',
              type: 'warning',
            });
          }

          let ids = [];
          selectedList.forEach((selected) => {
            ids.push(selected.id);
          });
          this.$refs.BtnDialogRef.openDialog({ ids, status: 'suspend' });
          this.getData();
          // this.$confirm('您确定要暂停合同吗？', '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   type: 'warning',
          // }).then(() => {
          //   let ids = [];
          //   selectedList.forEach((selected) => {
          //     ids.push(selected.id);
          //   });
          //   const params = {
          //     ids,
          //   };
          //   this.$axios.post(API.SUSPEND_LEASE_CONTRACT, params).then((res) => {
          //     if (res.data.code === 0) {
          //       this.$message({
          //         showClose: true,
          //         message: res.data.msg || '操作成功',
          //         type: 'success',
          //       });
          //       this.getData();
          //     } else {
          //       this.$message({
          //         showClose: true,
          //         message: res.data.msg,
          //         type: 'error',
          //       });
          //     }
          //   });
          // });
        }
      },
      // 删除,状态为待提交、已驳回的合同支持删除
      handleDelete() {
        if (this.resolveSelected('more')) {
          const selectedList = this.multipleSelection || [];
          let isDelete = true;
          selectedList.map((item) => {
            if (item.auditStatus != '01' && item.auditStatus != '04') {
              isDelete = false;
            }
          });
          if (isDelete) {
            console.log('删除');
            this.$confirm('您确定要删除合同吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              let ids = [];
              selectedList.forEach((selected) => {
                ids.push(selected.id);
              });
              const params = {
                ids,
              };
              this.$axios.post(API.DELETE, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg || '操作成功',
                    type: 'success',
                  });
                  this.getData();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
            });
          } else {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持删除，请核实！',
              type: 'error',
            });
          }
        }
      },
      // 启用 只有合同状态为暂停才可进行启用
      handleEnable() {
        console.log('enable');
        if (this.resolveSelected('more')) {
          const selectedList = this.multipleSelection || [];
          let hasErrorStatus = false;
          selectedList.map((item) => {
            if (item.contractStatus !== '05' || ['05', '06', '07'].includes(item.auditStatus)) {
              hasErrorStatus = true;
            }
          });
          if (hasErrorStatus) {
            return this.$message({
              showClose: true,
              message: '您选择的合同中有不满足启用条件的合同，请确认。',
              type: 'warning',
            });
          }
          let ids = [];
          selectedList.forEach((selected) => {
            ids.push(selected.id);
          });
          this.$refs.BtnDialogRef.openDialog({ ids, status: 'enable' });
          // this.$confirm('您确定要启用合同吗？', '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   type: 'warning',
          // }).then(() => {
          //   let ids = [];
          //   selectedList.forEach((selected) => {
          //     ids.push(selected.id);
          //   });
          //   const params = {
          //     ids,
          //   };
          //   this.$axios.post(API.ENABLE_LEASE_CONTRACT, params).then((res) => {
          //     if (res.data.code === 0) {
          //       this.$message({
          //         showClose: true,
          //         message: res.data.msg || '操作成功',
          //         type: 'success',
          //       });
          //       this.getData();
          //     } else {
          //       this.$message({
          //         showClose: true,
          //         message: res.data.msg,
          //         type: 'error',
          //       });
          //     }
          //   });
          // });
        }
      },
      // 导出
      handleExport() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        const ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        params.ids = ids;
        this.$axios.post(API.EXPORT_CONTRACT_API, params).then((res) => {
          console.log(res, '1111');
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 新建
      handleAdd() {
        this.toAddContract();
      },
      // 关闭
      async handleClose() {
        if (this.resolveSelected('more')) {
          const selectedList = this.multipleSelection || [];
          let hasErrorStatus = false;
          selectedList.map((item) => {
            if (
              item.contractStatus === '04' ||
              item.contractStatus === '03' ||
              ['02', '05', '07', '06'].includes(item.auditStatus)
            ) {
              hasErrorStatus = true;
            }
          });
          if (hasErrorStatus) {
            return this.$message({
              showClose: true,
              message: '您选择的合同中有不满足关闭条件的合同，请确认。',
              type: 'warning',
            });
          }
          let ids = [];
          selectedList.forEach((selected) => {
            ids.push(selected.id);
          });

          const res = await this.$axios.post(API.CLOSECONTRACT, {
            ids,
          });
          console.log(res, 'data');
          if (res.data.fail) {
            return this.$message({
              showClose: true,
              message: '该合同下有未完成的单据，不能关闭，请核实！',
              type: 'error',
            });
          } else {
            this.$refs.BtnDialogRef.openDialog({ ids, status: 'close' });
          }
        }
      },
      // 关联合同
      handleRelatedContract() {
        if (this.resolveSelected()) {
          // TODO 只有审核通过才能关联合同
          const selectedData = this.multipleSelection[0] || {};
          if (!['03', '08'].includes(selectedData.auditStatus)) {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持关联合同，请核实！',
              type: 'error',
            });
          }
          console.log('关联合同');
          this.contractId = selectedData.id;
          this.dialogVisible = true;
          this.dialogTitle = '关联合同';
        }
      },
      // 续签
      handleRenewal() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (selectedData.contractStatus !== '03') {
            return this.$message({
              showClose: true,
              message: '合同暂未到期，无法续签，请核实！',
              type: 'error',
            });
          }
          if (selectedData.sourceContractNo) {
            return this.$message({
              showClose: true,
              message: `该合同已经续签，续签合同编号${selectedData.sourceContractNo}`,
              type: 'warning',
            });
          }
          if (['05', '07', '06'].includes(selectedData.auditStatus)) {
            return this.$message({
              showClose: true,
              message: `该合同复核状态无法续签`,
              type: 'warning',
            });
          }
          const path = {
            path: 'propert/renewalLeaseContract',
            name: 'renewalLeaseContract',
            meta: {
              keepAlive: true,
              title: '续签租赁合同',
            },
            query: {
              type: 'renewal',
              contractId: selectedData.id,
            },
          };
          this.$router.push(path);
        }
      },
      // 变更
      handleChange() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          // TODO 合同下是否有未完成的单据
          if (
            ['03', '08'].includes(selectedData.auditStatus) &&
            (selectedData.contractStatus === '01' || selectedData.contractStatus === '02')
          ) {
            console.log('handleChange');
          } else {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持变更，请核实！',
              type: 'error',
            });
          }
          this.changeDialogVisible = true;
          this.changeContractId = selectedData.id;
        }
      },
      // 审核
      handleAudit() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (
            selectedData.auditStatus == '01' ||
            selectedData.auditStatus == '03' ||
            selectedData.auditStatus == '04' ||
            selectedData.auditStatus == '08'
          ) {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持审核，请核实！',
              type: 'error',
            });
          }
          console.log('跳转审核');
          const path = {
            path: 'property/auditLeaseContract',
            name: 'auditLeaseContract',
            meta: {
              keepAlive: true,
              title: '审核租赁合同',
            },
            query: {
              type: 'audit',
              contractId: selectedData.id,
            },
          };
          this.$router.push(path);
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择数据！',
            type: 'warning',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: '请选择一条数据！',
            type: 'warning',
          });
          return false;
        }
        return true;
      },
      handleSizeChange() {
        this.getData();
      },
      handleCurrentChange() {
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        params.ids = this.query.spaceIdsString ? this.query.spaceIdsString.split(',') : [];
        this.$axios.post(API.LEASE_CONTRACT_LIST_PAGE_V2, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.records || [];
            this.tableData.forEach((item) => {
              item.auditStatusName = this.transferSelect(item.auditStatus, this.auditStatusList);
              item.contractCategoryName = this.transferSelect(
                item.contractCategory,
                this.contractCategoryList
              );
              item.contractStatusName = this.transferSelect(
                item.contractStatus,
                this.contractStatusList
              );
              item.leaseDate =
                item.leaseDateFrom && item.leaseDateUntil
                  ? `${(item.leaseDateFrom || '').replaceAll('-', '.')}-${(
                      item.leaseDateUntil || ''
                    ).replaceAll('-', '.')}`
                  : '';
              if (item.expenseTypeCode) {
                item['rentAmount' + item.expenseTypeCode] = this.getRowRentAmount(
                  item,
                  'detailList'
                );
              }
              item.propertyAmount = this.getRowRentAmount(item, 'propertyAmountDetail');
              item.sanitationAmount = this.getRowRentAmount(item, 'sanitationAmountDetail');
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      // transferSelect(value, list, valueProp = 'value', labelField = 'label') {
      //   let item = XEUtils.find(list, (item) => item[valueProp] === value);
      //   return item ? item[labelField] : null;
      // },
      dblclickEvent(value) {
        const row = value.row;
        this.goContractDetail(row);
      },
    },
  };
</script>
